import {
  setResetPassword,
  setUser,
  startLoading,
  stopLoading,
} from "../slices/userSlice";
import { encryptText } from "../../utils/encryptText/encryptText";

const baseApi = process.env.REACT_APP_API_BASE;

export const getUserByUserAndPassword =
  (username, password, addNotification) => async (dispatch) => {
    try {
      dispatch(startLoading());

      const hashedPassword = encryptText(password);

      const response = await fetch(
        `${baseApi}user/login?username=${encodeURIComponent(
          username,
        )}&password=${encodeURIComponent(hashedPassword)}`,
      ).then((res) => res.json());

      if (response && response["_id"]) {
        dispatch(
          setUser({
            id: response._id,
            token: response.token,
          }),
        );
      } else if (response?.resetPassword) {
        dispatch(setResetPassword(true));
      } else {
        addNotification({
          id: Date.now(),
          message: "Wrong credentials!",
          kind: "danger",
        });
      }
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      dispatch(stopLoading());
    }
  };
